import React from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import DIGI from "../../../../assets/icons/digi.png";

export function AccountAggregatorInfoCard({
  onOpenAccountAggregatorModal,
  onCreateFIData,
  onGetFIData,
  showFIButtons = false,
  showGetFIButton = false,
}: {
  onOpenAccountAggregatorModal: () => void;
  onCreateFIData?: (item: any) => void;
  onGetFIData?: (item: any) => void;
  showFIButtons?: boolean;
  showGetFIButton?: boolean;
}) {
  return (
    <Box
      sx={{
        mt: 2,
        p: 2,
        ml: 2,
        backgroundColor: "rgba(255, 159, 67, 0.16)",
        borderRadius: "8px",
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
            <Box
              sx={{
                width: 26,
                height: 26,
                backgroundColor: "rgba(255, 159, 67, 1)",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <img
                src={DIGI}
                alt="Account Aggregator"
                style={{ height: 16, width: 16 }}
              />
            </Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                color: "#1F2233",
              }}
            >
              Account Aggregator
            </Typography>
          </Box>
          <Typography
            sx={{
              fontSize: "14px",
              color: "#1F2233",
              paddingLeft: "3%",
            }}
          >
            Account Aggregator is an RBI-regulated service that allows secure,
            consent-based sharing of your financial data directly from your bank
            without sharing passwords or login credentials.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography
            sx={{
              fontSize: "14px",
              color: "#666",
              mt: 1,
              lineHeight: 1.4,
            }}
          >
            If you wish to update your mobile number or change the statement
            duration in the Account Aggregator, please{" "}
            <Typography
              component="span"
              sx={{
                color: "#00b3b5",
                textDecoration: "underline",
                cursor: "pointer",
                "&:hover": { color: "#00999a" },
              }}
              onClick={onOpenAccountAggregatorModal}
            >
              Click here
            </Typography>
            .
          </Typography>
        </Grid>

        {
          <Grid item xs={12}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
              {onCreateFIData && showFIButtons && (
                <Button
                  variant="outlined"
                  size="small"
                  onClick={onCreateFIData}
                  sx={{
                    borderColor: "#00b3b5",
                    color: "#00b3b5",
                    textTransform: "none",
                    borderRadius: "8px",
                    fontWeight: 500,
                    fontSize: "13px",
                    "&:hover": {
                      borderColor: "#00999a",
                      color: "#00999a",
                      backgroundColor: "rgba(0,179,181,0.06)",
                    },
                  }}
                >
                  Retry FI Data Request
                </Button>
              )}
              {showGetFIButton && onGetFIData && (
                <Button
                  variant="contained"
                  size="small"
                  onClick={onGetFIData}
                  sx={{
                    backgroundColor: "#00b3b5",
                    color: "#fff",
                    textTransform: "none",
                    borderRadius: "8px",
                    fontWeight: 500,
                    fontSize: "13px",
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: "#00999a",
                      boxShadow: "none",
                    },
                  }}
                >
                  Get Document
                </Button>
              )}
            </Box>
          </Grid>
        }

      </Grid>
    </Box>
  );
}

